// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__4nWMe","primary":"style_primary__khNwd","normal":"style_normal__VAdmO"};